import {Theme, createStyles} from '@material-ui/core';

export const showcaseStyles = (theme: Theme) =>
	createStyles({
		root: {
			paddingTop: theme.spacing(5),
			color: theme.palette.common.white,
			backgroundColor: theme.palette.primary.main,
			[theme.breakpoints.down(theme.breakpoints.values.sm)]: {
				paddingTop: theme.spacing(3),
			},
			marginBottom: theme.spacing(14),
		},
		container: {
			padding: 0,
		},
		gridContainer: {
			paddingLeft: (window.innerWidth - 1232) / 2,
		},
		label: {
			fontSize: theme.typography.pxToRem(12),
			lineHeight: theme.typography.pxToRem(22),
			'&::before': {
				display: 'block',
				content: '""',
				width: 24,
				height: 1,
				backgroundColor: theme.palette.secondary.main,
				position: 'relative',
				left: -1 * theme.spacing(4.5),
				top: theme.spacing(1.5),

				[theme.breakpoints.down(theme.breakpoints.values.sm)]: {
					left: -1 * theme.spacing(3.8),
				},
			},
			[theme.breakpoints.up(theme.breakpoints.values.lg)]: {
				fontSize: theme.typography.pxToRem(14),
			},
			[theme.breakpoints.between(theme.breakpoints.values.sm, theme.breakpoints.values.md)]: {
				fontSize: theme.typography.pxToRem(10),
			},
		},
		catchPhrase: {
			fontSize: theme.typography.pxToRem(32),
			lineHeight: theme.typography.pxToRem(48),
			paddingTop: theme.spacing(2.2),
			overflowWrap: 'break-word',
			'& > .line': {
				display: 'inline-block',
				width: '100%',
			},
			[theme.breakpoints.up(theme.breakpoints.values.lg)]: {
				fontSize: theme.typography.pxToRem(53),
				lineHeight: theme.typography.pxToRem(62),
			},
			[theme.breakpoints.down(theme.breakpoints.values.md)]: {
				fontSize: theme.typography.pxToRem(24),
				lineHeight: theme.typography.pxToRem(30),
				paddingBottom: theme.spacing(4),
			},
			[theme.breakpoints.down(theme.breakpoints.values.sm)]: {
				lineHeight: theme.typography.pxToRem(30),
			},
		},
		arrows: {
			display: 'flex',
			justifyContent: 'flex-end',
			paddingRight: theme.spacing(4.5),
			paddingTop: theme.spacing(5.5),
			paddingBottom: theme.spacing(2),
			[theme.breakpoints.down(theme.breakpoints.values.md)]: {
				paddingTop: 0,
				paddingRight: 0,
			},
		},
		arrowButton: {
			color: theme.palette.primary.light,
			transition: 'color, transform',
			transitionDuration: `${theme.transitions.duration.standard}ms`,

			'&:hover': {
				color: theme.palette.common.white,
				background: 'none',
				transform: 'scale(1.2)',
			},
			'&:active': {
				color: theme.palette.secondary.main,
				background: 'none',
				transform: 'scale(1.2)',
			},
		},
		textBlock: {
			width: '35%',
			paddingTop: theme.spacing(9),
			[theme.breakpoints.down(theme.breakpoints.values.md)]: {
				paddingTop: theme.spacing(4),
			},
			[theme.breakpoints.down(theme.breakpoints.values.sm)]: {
				width: '100%',
				paddingTop: 0,
			},
		},
		slideshow: {
			width: '65%',
			marginBottom: theme.spacing(-14),
			zIndex: 1000,
			'& .slick-slide': {
				marginRight: theme.typography.pxToRem(3),
			},
			[theme.breakpoints.between(theme.breakpoints.values.sm, theme.breakpoints.values.md)]: {
				paddingLeft: theme.spacing(3),
			},
			[theme.breakpoints.down(theme.breakpoints.values.sm)]: {
				width: '100%',
				'& .slick-slider': {
					display: 'flex',
					flexDirection: 'column-reverse',
				},
				'& .slick-dots': {
					position: 'static',
					top: 'unset',
					bottom: 'unset',
					display: 'inline-block',
					paddingTop: theme.spacing(3),
					paddingBottom: theme.spacing(5),
					textAlign: 'left',
				},
				'& li button:before': {
					color: `${theme.palette.primary.light} !important`,
					opacity: '1 !important',
					fontSize: '12px !important',
				},
				'& li.slick-active button:before': {
					color: `${theme.palette.secondary.main} !important`,
					opacity: '1 !important',
					fontSize: '12px !important',
				},
			},
		},
		dots: {},
	});
